import { CONFIGURATION_ERROR } from 'utils/types';

export function validatePxConfigurations(configurations) {
  const allowCardNumSearch = convertToBoolean(
    configurations.allowCardNumSearch
  );
  const allowEmailSearch = convertToBoolean(configurations.allowEmailSearch);
  const allowPhoneNumSearch = convertToBoolean(
    configurations.allowPhoneNumSearch
  );
  const allowNameSearch = convertToBoolean(configurations.allowNameSearch);
  const allowCompCardSearch = convertToBoolean(
    configurations.allowCompCardSearch
  );
  const disableTrackingUrl = convertToBoolean(
    configurations.disableTrackingUrl
  );
  const lookUpByCheckInCode = convertToBoolean(
    configurations.lookUpByCheckInCode
  );
  const merchantId = configurations.merchantId;
  const storeCode = configurations.storeCode;
  const isTrainingMode = convertToBoolean(configurations.isTrainingMode);

  let environmentUrl = configurations.environmentUrl;

  if (!(merchantId && storeCode && environmentUrl)) {
    const configurationError = new Error(
      'Missing required Paytronix configurations'
    );
    configurationError.name = CONFIGURATION_ERROR;
    throw configurationError;
  }

  if (environmentUrl.endsWith('/')) {
    environmentUrl = environmentUrl.slice(0, -1);
  }

  return {
    allowCardNumSearch,
    allowEmailSearch,
    allowPhoneNumSearch,
    allowNameSearch,
    environmentUrl,
    lookUpByCheckInCode,
    merchantId,
    storeCode,
    isTrainingMode,
    allowCompCardSearch,
    disableTrackingUrl,
  };
}

export function convertToBoolean(value) {
  return String(value).toLowerCase() === 'true';
}
